<!-- #region header -->
<div class="iu-email-editor-header">
  <!-- template first: choosing one fills subject and body -->
  @if (templates$ | async; as templates) {
    <div class="iu-email-editor-row iu-email-editor-row-template">
      <span class="iu-email-editor-label">{{ 'email.template' | translate }}</span>
      <div class="iu-email-editor-field">
        <iu-autocomplete-ui
          #emailModelAutocomplete
          [columnName]="'email-templates'"
          [cssClass]="'p-col-12 iu-email-editor-header-field'"
          [data]="templates"
          [fieldValue]="defaultEmailModel"
          [isLabelDisplay]="false"
          label="{{ 'email.emailModels' | translate }}"
          [limitSuggestions]="3"
          tooltip="{{ 'email.emailModels' | translate }}"
          (autoCompleteEmitter)="selectTemplate($event.model)"
          (fieldValueModified)="defaultEmailModel = $event" />
      </div>
    </div>
  }

  <div class="iu-email-editor-row">
    <span class="iu-email-editor-label">{{ 'email.to' | translate }}</span>
    <div class="iu-email-editor-field">
      <iu-input-chips-ui
        [addOnBlur]="true"
        [addOnSpace]="true"
        [columnName]="'email-destination'"
        [cssClass]="'p-col-12 iu-email-editor-header-field'"
        [editOnBackspace]="true"
        [inContainer]="true"
        [inputStyle]="{ background: 'var(--email-editor-bg-color-header-field)' }"
        [isLabelDisplay]="false"
        [label]="'email.destination' | translate"
        [matchPattern]="regexMail"
        [(fieldValue)]="to" />
    </div>
    @if (!displayCC || !displayCCI) {
      <div class="iu-email-editor-row-actions">
        @if (!displayCC) {
          <button
            class="iu-email-editor-link-btn"
            data-cy="email-add-cc"
            type="button"
            [title]="'email.addCC' | translate"
            (click)="displayCC = true">
            {{ 'email.addCcShort' | translate }}
          </button>
        } @else {
          <button
            class="iu-email-editor-link-btn"
            data-cy="email-add-cci"
            type="button"
            [title]="'email.addCCI' | translate"
            (click)="displayCCI = true">
            {{ 'email.addCciShort' | translate }}
          </button>
        }
      </div>
    }
  </div>

  @if (displayCC) {
    <div class="iu-email-editor-row">
      <span class="iu-email-editor-label">{{ 'email.cc' | translate }}</span>
      <div class="iu-email-editor-field">
        <iu-input-chips-ui
          [addOnBlur]="true"
          [addOnSpace]="true"
          [columnName]="'email-cc'"
          [cssClass]="'p-col-12 iu-email-editor-header-field'"
          [editOnBackspace]="true"
          [inContainer]="true"
          [inputStyle]="{ background: 'var(--email-editor-bg-color-header-field)' }"
          [isLabelDisplay]="false"
          [label]="'CC'"
          [matchPattern]="regexMail"
          [(fieldValue)]="cc" />
      </div>
    </div>
  }

  @if (displayCCI) {
    <div class="iu-email-editor-row">
      <span class="iu-email-editor-label">{{ 'email.bcc' | translate }}</span>
      <div class="iu-email-editor-field">
        <iu-input-chips-ui
          [addOnBlur]="true"
          [addOnSpace]="true"
          [columnName]="'email-cci'"
          [cssClass]="'p-col-12 iu-email-editor-header-field'"
          [editOnBackspace]="true"
          [inContainer]="true"
          [inputStyle]="{ background: 'var(--email-editor-bg-color-header-field)' }"
          [isLabelDisplay]="false"
          [label]="'CCI'"
          [matchPattern]="regexMail"
          [(fieldValue)]="cci" />
      </div>
    </div>
  }

  <div class="iu-email-editor-row">
    <span class="iu-email-editor-label">{{ 'email.subject' | translate }}</span>
    <div class="iu-email-editor-field">
      <iu-input-text-ui
        [columnName]="'email-subject'"
        [cssClass]="'p-col-12 iu-email-editor-header-field'"
        [isLabelDisplay]="false"
        [label]="'email.subject' | translate"
        [(fieldValue)]="subject" />
    </div>
  </div>
</div>
<!-- #endregion -->
<!-- #region body -->
<div class="iu-email-editor-body">
  <div #quillHeader>
    @if (!isMobile) {
      <!-- desktop -->
      <div class="iu-email-editor-body-header">
        <ng-container [ngTemplateOutlet]="headerAndFont" />

        <ng-container [ngTemplateOutlet]="others" />
      </div>
    } @else {
      <!-- mobile -->
      <div class="iu-email-editor-mobile">
        <div class="iu-email-editor-mobile-menu-display" (click)="displayMobileMenu = !displayMobileMenu">
          Menu<span
            style="margin-left: 5px"
            [ngClass]="['fa', displayMobileMenu ? 'fa-chevron-down' : 'fa-chevron-right']"></span>
        </div>
        <div class="iu-email-editor-mobile-menu" [ngStyle]="{ display: displayMobileMenu ? 'flex' : 'none' }">
          <div class="iu-email-editor-mobile-menu-fieldset">
            <ng-container [ngTemplateOutlet]="headerAndFont" />
          </div>
          <div class="iu-email-editor-mobile-menu-fieldset">
            <ng-container [ngTemplateOutlet]="others" />
          </div>
        </div>
      </div>
    }
  </div>
  <div #quillEditor data-cy="email-body" [ngStyle]="style"></div>
</div>
<!-- #endregion -->
<!-- #region attachments -->
<section class="iu-email-editor-attachments" [class.is-empty]="!isLoaderActive && !uploadedFiles.length">
  <div class="iu-email-editor-attachments-header">
    <i aria-hidden="true" class="icon-attach3x"></i>
    <span>{{ 'email.attachments' | translate }}</span>
    <span class="iu-email-editor-attachments-count">{{ uploadedFiles.length }}</span>
  </div>
  <div class="iu-email-editor-footer-attachement">
    <iu-input-file-ui
      [auto]="true"
      [data]="{ isParam: false, columnName: 'email-fileupload' }"
      [displayButtons]="false"
      [displayFileUploaded]="true"
      [isLoaderActive]="isLoaderActive"
      [multiple]="true"
      [mustGet]="false"
      [styleClass]="'iu-email-editor-fileupload'"
      [type]="'EMAIL_ATTACHEMENT'"
      [uploadedFileList_noFiles]="'email.noAttachedFiles'"
      [uploadedFileList_title]="'email.attachedFilesTitle'"
      [uploadedFiles]="uploadedFiles"
      [uploadingFileList_drag]="'email.dropFiles'"
      [uploadingFileList_title]="'email.attachFiles'" />
  </div>
</section>
<!-- #endregion -->
<!-- #region footer -->
<div class="iu-email-editor-footer">
  <span class="iu-email-editor-footer-hint">{{ 'email.sendShortcut' | translate }}</span>
  <div class="iu-email-editor-footer-buttons">
    <button class="p-button p-button-secondary" type="button" (click)="cancelEmailEmitter.emit()">
      {{ 'email.cancel' | translate }}
    </button>
    <button
      class="p-button p-button-primary"
      data-cy="email-send-button"
      type="button"
      [disabled]="isLoaderActive"
      [title]="'email.sendEmail' | translate"
      (click)="sendEmail($event)">
      <i aria-hidden="true" class="icon-send"></i>
      {{ 'email.send' | translate }}
    </button>
  </div>
</div>
<!-- #endregion -->

<!-- #region Templates -->
<ng-template #headerAndFont>
  <select class="ql-header">
    <option value="1">{{ 'email.header.heading' | translate }}</option>
    <option value="2">{{ 'email.header.subheading' | translate }}</option>
    <option selected>{{ 'email.header.normal' | translate }}</option>
  </select>
  <select class="ql-font">
    <option selected>Sans Serif</option>
    <option value="serif">Serif</option>
    <option value="monospace">Monospace</option>
    <option value="calibri">Calibri</option>
    <option value="arial">Arial</option>
    <option value="times-new-roman">Times new roman</option>
  </select>
</ng-template>

<ng-template #others>
  <button
    class="ql-bold"
    type="button"
    [attr.aria-label]="'email.font.weight.bold' | translate"
    [title]="'email.font.weight.bold' | translate">
    {{ 'email.font.weight.bold' | translate }}
  </button>
  <button
    class="ql-italic"
    type="button"
    [attr.aria-label]="'email.font.weight.italic' | translate"
    [title]="'email.font.weight.italic' | translate">
    {{ 'email.font.weight.italic' | translate }}
  </button>
  <button
    class="ql-underline"
    type="button"
    [attr.aria-label]="'email.font.weight.underline' | translate"
    [title]="'email.font.weight.underline' | translate">
    {{ 'email.font.weight.underline' | translate }}
  </button>
  <select
    class="ql-color"
    [attr.aria-label]="'email.color.foreground' | translate"
    [title]="'email.color.foreground' | translate"></select>
  <select
    class="ql-background"
    [attr.aria-label]="'email.color.background' | translate"
    [title]="'email.color.background' | translate"></select>
  <button
    class="ql-list"
    type="button"
    value="ordered"
    [attr.aria-label]="'email.list.ordered' | translate"
    [title]="'email.list.ordered' | translate"></button>
  <button
    class="ql-list"
    type="button"
    value="bullet"
    [attr.aria-label]="'email.list.unordered' | translate"
    [title]="'email.list.unordered' | translate"></button>
  <select class="ql-align" [attr.aria-label]="'email.alignment' | translate" [title]="'email.alignment' | translate">
    <option selected></option>
    <option value="center"></option>
    <option value="right"></option>
    <option value="justify"></option>
  </select>
  <button
    class="ql-link"
    type="button"
    [attr.aria-label]="'email.insert.link' | translate"
    [title]="'email.insert.link' | translate"></button>
  <button
    class="ql-image"
    type="button"
    [attr.aria-label]="'email.insert.image' | translate"
    [title]="'email.insert.image' | translate"></button>
  <button
    class="ql-code-block"
    type="button"
    [attr.aria-label]="'email.insert.code' | translate"
    [title]="'email.insert.code' | translate"></button>
  <button
    class="ql-clean"
    type="button"
    [attr.aria-label]="'email.removeStyles' | translate"
    [title]="'email.removeStyles' | translate"></button>
</ng-template>

<!-- #endregion -->
